module.exports = __webpack_public_path__ + "06_hige_black.df1c6381.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/06_hige_black.png
// module id = vlXd
// module chunks = 0